import React, { useState } from "react";
import { TextField, FormControl, Box, Button } from "@mui/material";
import { useSnackbar } from "notistack";
import axios from "axios";
import { url } from "../../Constant";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import {
  inputFieldStyle,
  inputFieldContainer,
  formControlContainer,
  uploadButton,
  cancelButton,
} from "./VideoUploadStyling";
import SelectInput from "./SelectInput";

const intialState = {
  videoLink: "",
  previewImage: "",
  title: "",
  genre: "",
  contentRating: "",
  releaseDate: null,
};

const VideoUpload = (props) => {
  const [values, setValues] = useState(intialState);
  const { enqueueSnackbar } = useSnackbar();
  // const [releaseDate, setReleaseDate] = useState("");

  const GenreList = [
    { name: "All", value: "All", id: "All" },
    { name: "Education", value: "Education", id: "Education" },
    { name: "Sports", value: "Sports", id: "Sports" },
    { name: "Comedy", value: "Comedy", id: "Comedy" },
    { name: "Lifestyle", value: "Lifestyle", id: "Lifestyle" },
  ];
  const ageList = [
    { name: "All", value: "Anyone", id: "Anyone" },
    { name: "7+", value: "7+", id: "7+" },
    { name: "12+", value: "12+", id: "12+" },
    { name: "16+", value: "16+", id: "16+" },
    { name: "18+", value: "18+", id: "18+" },
  ];

  const formSubmission = async (formData) => {
    console.log(formData);
    if (validateInput(formData)) {
      try {
        const urlData = await axios.post(`${url}/v1/videos`, values);
        enqueueSnackbar("Upload Successfull", {
          variant: "success",
        });
        return urlData;
      } catch (error) {
        if (error.response.status >= 400 && error.response.status <= 499) {
          enqueueSnackbar(error.response.data.message, {
            variant: "error",
          });
        } else {
          enqueueSnackbar(
            "Something went wrong. Check that the backend is running, reachable and returns valid JSON.",
            {
              variant: "error",
            }
          );
        }
      }
    }
  };

  const validateInput = (data) => {
    if (data.videoLink === "") {
      enqueueSnackbar("Video Link is a required field", {
        variant: "error",
      });
      return false;
    }
    if (data.previewImage === "") {
      enqueueSnackbar("Preview Image is a required field", {
        variant: "error",
      });
      return false;
    }
    if (data.title === "") {
      enqueueSnackbar("Title is a required field", {
        variant: "error",
      });
      return false;
    }
    if (data.genre === "") {
      enqueueSnackbar("Genre is a required field", {
        variant: "error",
      });
      return false;
    }
    if (data.contentRating === "") {
      enqueueSnackbar("Content Rating is a required field", {
        variant: "error",
      });
      return false;
    }
    if (data.releaseDate === "") {
      enqueueSnackbar("Release Date is a required field", {
        variant: "error",
      });
      return false;
    }
    return true;
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setValues({
      ...values,
      [name]: value,
    });
  };

  return (
    <>
      <FormControl style={formControlContainer}>
        <Box style={inputFieldContainer}>
          <TextField
            id="outlined-basic"
            label="Video Link"
            variant="outlined"
            style={inputFieldStyle}
            helperText="This link will be used to derive the video"
            name="videoLink"
            value={values.videoLink}
            onChange={(e) => handleInputChange(e)}
          />
        </Box>
        <Box style={inputFieldContainer}>
          <TextField
            id="outlined-basic"
            label="Thumbnail Image Link"
            variant="outlined"
            style={inputFieldStyle}
            helperText="This link will be used to preview the thumbnail image"
            name="previewImage"
            value={values.previewImage}
            onChange={handleInputChange}
          />
        </Box>
        <Box style={inputFieldContainer}>
          <TextField
            id="outlined-basic"
            label="Title"
            variant="outlined"
            style={inputFieldStyle}
            helperText="The title will be the representative text for video"
            name="title"
            value={values.title}
            onChange={handleInputChange}
          />
        </Box>
        <Box id="a" style={inputFieldContainer}>
          <SelectInput
            value={values.genre}
            label="Genre"
            List={GenreList}
            helperText="Genre will help in categorizing your videos"
            name="genre"
            handleInputChange={handleInputChange}
          />
        </Box>
        <Box id="b" style={inputFieldContainer}>
          <SelectInput
            value={values.contentRating}
            label="Suitable age group for the clip"
            List={ageList}
            helperText="This will be used to filter videos on age group suitability"
            name="contentRating"
            handleInputChange={handleInputChange}
          />
        </Box>
        <Box style={inputFieldContainer}>
          <LocalizationProvider
            dateAdapter={AdapterDateFns}
            style={inputFieldStyle}
          >
            <DesktopDatePicker
              fullWidth
              inputFormat="dd/MM/yyyy"
              style={inputFieldStyle}
              label="Release date"
              value={values.releaseDate}
              onChange={(date) => {
                setValues({
                  ...values,
                  releaseDate: date,
                });
              }}
              helperText="This will be used to sort videos"
              renderInput={(params) => (
                <TextField
                  {...params}
                  sx={{
                    display: "flex",
                    width: "100%",
                  }}
                  id="upload-btn-release-date"
                  className="inputDiv  floatingLabelFocusStyle"
                  InputLabelProps={{
                    className: "floatingLabelFocusStyle",
                  }}
                />
              )}
            />
          </LocalizationProvider>
        </Box>
        <Box style={inputFieldContainer}>
          <Button
            variant="contained"
            style={uploadButton}
            onClick={() => formSubmission(values)}
            id="upload-btn-submit"
          >
            Upload
          </Button>
          <Button
            variant="text"
            style={cancelButton}
            onClick={() => props.onClose()}
            id="upload-btn-cancel"
          >
            Cancel
          </Button>
        </Box>
      </FormControl>
    </>
  );
};

export default VideoUpload;
